var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import classNames from "classnames";
import { isNumber } from "lodash";
import React from "react";
import styles from "../statics/styles/loaders.rtlignore.scss";
const styleLoader = {
  position: "absolute",
  top: "0"
};
function createFakeProgressStepper(onProgress, approximateExpectedDuration = 5e3) {
  let lastTimeoutId;
  let progress = 0;
  const startDate = Date.now();
  const getTimeoutDelay = () => {
    const linearStep = approximateExpectedDuration / 100;
    if (progress <= 25) {
      return linearStep / 4;
    } else if (progress <= 50) {
      return linearStep / 3;
    } else if (progress <= 90) {
      return linearStep / 1.5;
    } else {
      const timeRemaining = approximateExpectedDuration - (Date.now() - startDate);
      return timeRemaining / (100 - progress);
    }
  };
  const run = () => {
    progress += 1;
    if (progress >= 100) {
      return;
    }
    lastTimeoutId = setTimeout(run, getTimeoutDelay());
    onProgress(progress);
  };
  run();
  return () => {
    clearTimeout(lastTimeoutId);
  };
}
class Loader extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { percent: 1 });
    __publicField(this, "resetFakeLoader");
  }
  componentDidMount() {
    const { percent } = this.props;
    if (!isNumber(percent)) {
      let approximateExpectedDuration;
      if (this.props.isFastFakeLoader) {
        approximateExpectedDuration = 8500;
      }
      if (this.props.isVerySlowFakeLoader) {
        approximateExpectedDuration = 5e4;
      }
      this.resetFakeLoader = createFakeProgressStepper(
        (percent2) => this.setState({ percent: percent2 }),
        approximateExpectedDuration
      );
    }
  }
  componentWillUnmount() {
    this.resetFakeLoader && this.resetFakeLoader();
  }
  renderProgress() {
    const percent = isNumber(this.props.percent) ? this.props.percent : this.state.percent;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.progress, {
          [styles[this.props.type]]: this.props.type
        })
      },
      `${percent}%`
    ));
  }
  render() {
    const style = this.state.localUrl ? __spreadProps(__spreadValues({}, styleLoader), { backgroundImage: `url(${this.state.localUrl})` }) : styleLoader;
    return /* @__PURE__ */ React.createElement("div", { className: classNames(styles.loaderOverlay), "data-hook": "loader", style }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.loader, {
          [styles[this.props.type]]: this.props.type
        })
      }
    ), this.props.disableProgress ? null : this.renderProgress());
  }
}
__publicField(Loader, "defaultProps", {
  type: "mini",
  isFastFakeLoader: true
});
var Loader_default = Loader;
export {
  Loader_default as default
};
//# sourceMappingURL=Loader.js.map
